export type Bonus = {
  number: string
  name: string
  summary: string
  details: string
  pages: string
  value: number
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    name: 'Clinical Balance Assessment Toolkit',
    summary: 'Professional tools for organizing balance, gait, and functional mobility assessments.',
    details:
      'Includes assessment selection guides, observation forms, reassessment records, and printable clinical worksheets. Designed to support standardized testing using the appropriate official protocols.',
    pages: '40 pages of practical assessment resources',
    value: 12,
  },
  {
    number: '02',
    name: 'Chair-Based Rehabilitation Protocols',
    summary: 'Specialized seated rehabilitation techniques for older adults with limited standing tolerance.',
    details:
      'Includes trunk control, pelvic coordination, functional reaching, seated balance tasks, and structured treatment protocols — with positioning, sets, repetitions, rest, and modifications.',
    pages: '40 pages of seated rehabilitation exercises and protocols',
    value: 12,
  },
  {
    number: '03',
    name: 'Patient Home Exercise Pack',
    summary:
      'Illustrated, clinician-prescribed home exercises and practical routines for appropriately selected older adults.',
    details:
      'Includes seated mobility, supported strengthening, functional movement, walking activities, weekly calendars, and patient tracking sheets.',
    pages: '40 pages of home exercises and printable patient resources',
    value: 15,
  },
  {
    number: '04',
    name: 'Fall Prevention & Caregiver Support Kit',
    summary: 'Practical tools for reviewing home safety and organizing appropriate caregiver support.',
    details:
      'Includes room-by-room safety checklists, environmental modifications, caregiver guidance, fall-response planning, and printable worksheets.',
    pages: '40 pages of home safety and caregiver resources',
    value: 12,
  },
  {
    number: '05',
    name: 'Clinical Progress Tracking System',
    summary: 'Professional templates for documenting rehabilitation sessions and monitoring patient progress.',
    details:
      'Includes exercise logs, dosage trackers, functional goal sheets, reassessment schedules, multiweek dashboards, and progress reports.',
    pages: '40 pages of clinical documentation tools',
    value: 10,
  },
]

export const pricing = {
  bonusValue: 61,
  price: '26.90',
}

export const offerDescription =
  'The complete professional system for advanced rehabilitation techniques, structured clinical protocols, and practical treatment tools.'

export const checkoutFeatures = [
  '5 Complete Professional Volumes',
  '5 Practical Bonuses',
  'Advanced Postural Control Techniques',
  'Gait Retraining & Locomotor Rehabilitation',
  'Functional Strength & Movement Training',
  'Reactive Balance & Motor Adaptation',
  'Complete 20-, 30-, and 40-Minute Sessions',
  'Multiweek Rehabilitation Programs',
  'Step-by-Step Exercise Instructions',
  'Sets, Repetitions & Rest Periods',
  'Clinical Regressions & Progressions',
  'Assessment & Progress Tracking Tools',
  'Home Exercise & Caregiver Resources',
  'Instant Digital Access',
  '7-Day Guarantee',
]
